{
  "slug": "highest-iq-ever-recorded",
  "title": "What is the highest IQ ever recorded?",
  "description": "Examine famous highest-IQ claims, test ceilings, incompatible score scales, and why no scientifically definitive world ranking exists.",
  "summary": "There is no single defensible answer to the highest-IQ question. Very high scores are difficult to estimate, tests use different scales and ceilings, and many famous claims lack an authenticated report.",
  "category": "IQ score interpretation",
  "sections": [
    {
      "heading": "Why record claims are not directly comparable",
      "paragraphs": [
        "An IQ number only has meaning in relation to a named instrument, edition, age norm, score type, and administration. A score from one scale cannot be ranked directly against a number from another without a justified conversion.",
        "Older ratio-IQ calculations, modern deviation scores, childhood results, extended norms, and unsupervised quizzes are often mixed in popular lists even though they answer different measurement questions."
      ]
    },
    {
      "heading": "Extreme scores have greater uncertainty",
      "paragraphs": [
        "Tests contain a finite number and difficulty range of items. Near the upper ceiling, a small raw-score difference may produce a large reported difference, and the reference sample contains relatively few comparable observations.",
        "A precise-looking value in the extreme tail should therefore be interpreted with its confidence interval and technical limitations. Extrapolated values are not equivalent to directly supported scores."
      ]
    },
    {
      "heading": "How to evaluate a famous claim",
      "paragraphs": [
        "Look for a primary report naming the test, edition, date, age, conditions, norm group, and score. A quotation repeated across list articles without that evidence does not become verified through repetition.",
        "It is reasonable to describe documented achievements. It is not scientifically responsible to convert accomplishment, education, or fictional behavior into an exact IQ number."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Is an IQ of 200 possible?",
      "answer": "A number can appear under some historical or extended scoring methods, but its meaning and precision depend entirely on the instrument and norms."
    },
    {
      "question": "Who has the highest IQ today?",
      "answer": "No comprehensive, comparable, independently verified worldwide ranking exists across the many tests and score scales."
    }
  ],
  "related": ["iq-160-meaning", "how-is-iq-measured", "albert-einstein-iq"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — IQ",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "Pearson — WAIS-5 sample score report",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
